export default __webpack_public_path__ + "static/media/orders-animation.828af17d.mp4";